var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timer",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48 15C40.8799 15 33.9197 17.1114 27.9995 21.0671C22.0793 25.0228 17.4651 30.6453 14.7404 37.2234C12.0156 43.8015 11.3027 51.0399 12.6917 58.0233C14.0808 65.0066 17.5095 71.4212 22.5442 76.4558C27.5789 81.4905 33.9935 84.9192 40.9768 86.3083C47.9601 87.6973 55.1985 86.9844 61.7766 84.2597C68.3548 81.5349 73.9772 76.9207 77.9329 71.0005C81.8887 65.0804 84 58.1201 84 51C83.9891 41.4556 80.1927 32.3052 73.4438 25.5562C66.6949 18.8073 57.5445 15.0109 48 15ZM65.1225 38.1225L50.1225 53.1225C49.8438 53.4012 49.5129 53.6223 49.1487 53.7732C48.7845 53.924 48.3942 54.0017 48 54.0017C47.6058 54.0017 47.2155 53.924 46.8513 53.7732C46.4871 53.6223 46.1562 53.4012 45.8775 53.1225C45.5988 52.8438 45.3777 52.5129 45.2268 52.1487C45.076 51.7845 44.9983 51.3942 44.9983 51C44.9983 50.6058 45.076 50.2155 45.2268 49.8513C45.3777 49.4871 45.5988 49.1562 45.8775 48.8775L60.8775 33.8775C61.1562 33.5988 61.4871 33.3777 61.8513 33.2268C62.2155 33.076 62.6058 32.9983 63 32.9983C63.3942 32.9983 63.7845 33.076 64.1487 33.2268C64.5129 33.3777 64.8438 33.5988 65.1225 33.8775C65.4012 34.1562 65.6223 34.4871 65.7732 34.8513C65.924 35.2155 66.0017 35.6058 66.0017 36C66.0017 36.3942 65.924 36.7845 65.7732 37.1487C65.6223 37.5129 65.4012 37.8438 65.1225 38.1225ZM36 6C36 5.20435 36.3161 4.44129 36.8787 3.87868C37.4413 3.31607 38.2044 3 39 3H57C57.7957 3 58.5587 3.31607 59.1213 3.87868C59.6839 4.44129 60 5.20435 60 6C60 6.79565 59.6839 7.55871 59.1213 8.12132C58.5587 8.68393 57.7957 9 57 9H39C38.2044 9 37.4413 8.68393 36.8787 8.12132C36.3161 7.55871 36 6.79565 36 6Z",
    fill: "var(--fill-0, #FCFF68)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.b14c1a9b96983ab8c84b8e0ba5cc4357.svg";
export { ForwardRef as ReactComponent };